import { useCallback } from 'react';

export const useUrlSync = (selectedProducts) => {
  const saveBuildToUrl = useCallback(() => {
    const buildSlugs = Object.values(selectedProducts)
      .filter(product => product.slug)
      .map(product => product.slug);

    const currentUrl = new URL(window.location);

    if (buildSlugs.length > 0) {
      currentUrl.searchParams.set('b', buildSlugs.join(','));
    } else {
      currentUrl.searchParams.delete('b');
    }

    const shareUrl = currentUrl.toString();

    if (navigator.clipboard) {
      navigator.clipboard.writeText(shareUrl).then(() => {
        alert('🎉 Build link copied to clipboard!\n\nShare it or bookmark it to save this configuration.');
      }).catch(() => {
        prompt('Copy this link to share your build:', shareUrl);
      });
    } else {
      prompt('Copy this link to share your build:', shareUrl);
    }
  }, [selectedProducts]);

  return { saveBuildToUrl };
};
